import { InputBaseComponentProps, TextFieldProps } from '@material-ui/core';
import React, { FunctionComponent } from 'react';
import ReactInputMask from 'react-input-mask';
import ObscurableField from '../ObscurableField';

export type ItinFieldProps = TextFieldProps;

export function ItinField({ ...props }: ItinFieldProps): JSX.Element {
  return (
    <ObscurableField
      label="Individual Taxpayer ID"
      // commenting out until we can get this put in the right place when we implement saving
      // data-testid="tax-id-field"
      {...props}
      obscurePattern={/\d/g}
      obscureReplacer={(match, offset) => {
        if (offset < 6) {
          return '•';
        }
        return match;
      }}
      InputProps={{
        inputComponent: ReactInputMask as unknown as FunctionComponent<InputBaseComponentProps>,
        inputProps: {
          inputComponent: ReactInputMask,
          mask: '999-99-9999',
        },
      }}
    />
  );
}
export default ItinField;
